import React from 'react';
import LinkWithQuery from '../LinkWithQuery';

export default function ButtonCta({ url, copy, classes = '' }) {
	return (
		<LinkWithQuery to={url} className={`c-cta ${classes}`}>
			{copy}
		</LinkWithQuery>
	);
}
